function Checkbox(props) {
	const { value, disabled, checked, defaultChecked, onChange, className, children } = props;
	return (
		<label className={className ? `gs-check-item ${className}` : 'gs-check-item'}>
			<input
				type="checkbox"
				id={value}
				name={value}
				value={value}
				disabled={disabled}
				checked={checked}
				defaultChecked={defaultChecked}
				onChange={onChange}
			/>
			<span>{children ? <em>{children}</em> : null}</span>
		</label>
	);
}

function CheckboxGroup(props) {
	const { id, label, ckeckOptions, checked, setChecked, className } = props;

	const handleCheckboxChange = (e) => {
		const value = e.target.value;

		if (checked.indexOf(value) !== -1) {
			const newSelected = checked.filter((s) => s !== value);
			setChecked(newSelected);
			return;
		}

		setChecked([...checked, value]);
	};

	const checkItem = ckeckOptions.map((option, i) => {
		const { value, label, disabled } = option;
		return (
			<Checkbox
				key={value}
				id={value}
				name={value}
				value={value}
				disabled={disabled}
				defaultChecked={checked.includes(value)}
				onChange={handleCheckboxChange}
			>
				{label ? label : value}
			</Checkbox>
		);
	});

	return (
		<div className={className ? `gs-check-group ${className}` : 'gs-check-group'}>
			{label && <div className="gs-group-label">{label}</div>}
			<div
				id={id}
				className="gs-check-con"
				role="group"
				aria-label={label ? undefined : `${id}-label`}
				aria-labelledby={label ? `${id}-label` : undefined}
			>
				{checkItem}
			</div>
		</div>
	);
}

export { Checkbox, CheckboxGroup };
